import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const ROTA_TROCA_SENHA = '/conta/senha';

/** Com troca de senha obrigatória, a única rota acessível é /conta/senha. */
export const trocaSenhaGuard: CanActivateChildFn = (_rota, state) => {
  const auth = inject(AuthService);
  if (auth.usuario()?.trocaSenhaObrigatoria !== true) {
    return true;
  }
  const url = state.url.split('?')[0];
  return url === ROTA_TROCA_SENHA ? true : inject(Router).createUrlTree([ROTA_TROCA_SENHA]);
};
